export default __webpack_public_path__ + "static/fog-2-8aeda6af6c952275e3de75b0cd2ce679.png";